<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <refund-search :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <!-- <add-btn v-hasPermi="['cont:newIncome:add']" @add="handleAddPayment" /> -->
    <van-tabs v-model="active" @change="handleClick">
      <van-tab name="1" title="企微审批中" :badge="countItem.spzCount != 0?countItem.spzCount:''"></van-tab>
      <van-tab name="2" title="通过待退款" :badge="countItem.tgCount != 0?countItem.tgCount:''"></van-tab>
      <van-tab name="3" title="审批驳回" :badge="countItem.bhCount != 0?countItem.bhCount:''"></van-tab>
      <van-tab name="4" title="出纳已退款" :badge="countItem.ytkCount != 0?countItem.ytkCount:''"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item, index) in list" :key="index" @click="toDetails(item)" >
        <div style="display: flex; align-items: center; height:100%; width:100%">
          <div style="flex: 1; font-size: 12px;">
            <div class="custName-wrap">
              <div class="custName">
                <van-icon name="bookmark" color="green" />{{ item.contractName.split('【')[0] }}
                <span>
                  <van-tag round>广告类型:{{ formatHandel('accountType',item.accountType) }}</van-tag>
                </span>
              </div>
            </div>
            <div style="margin-left: 16px;">{{ item.contractNum }}</div>
            <div style="color: #1989fa">
              【{{ item.contractName.split('【')[1] }}
            </div>
            <div v-if="item.execCustomerName">执行客户：{{ item.execCustomerName }}</div>
            <div>付款单位：{{item.payCustName}}</div>
            <div>退款总金额：<span style="color: #ee0a24; ">{{item.refundMoney}}(元)</span>&nbsp;&nbsp;&nbsp;&nbsp;充值剩余金额：<span style="color: #ff976a; ">{{item.rechargeRemainMoney}}(元)</span></div>
            <div style="color: #666;">
              {{item.deptName}}<span style="color: #1989fa; margin: 0 5px;">{{item.userName}}</span>
            </div>
            <div>添加时间：{{item.createTime}}</div>
          </div>
          <!-- <van-icon style="flex:0.1;" color="#c1c1c1" name="arrow" size="16" class="arrow-color" /> -->
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
  </div>
</template>

<script>
// import payment from '@/api/cont/payment'
import refund from '@/api/fina/refund'
import SearchComponent from '@/components/common/Search'
import RefundSearch from '@/views/fina/components/RefundSearch.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import { Tab, Tabs } from 'vant'

export default {
  name: 'approve',
  components: {
    SearchComponent,
    RefundSearch,
    EmptyComponent,
    TotalComponent,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data() {
    return {
      add_show: false,
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      countItem: {
        spzCount: null,
        tgCount: null,
        bhCount: null,
        ytkCount: null
      },
      showFilterPop: false,
      custList: [],
      paymentFormShow: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        acconutStatus: 1,
        scrollTop: null
      },
      options: {
        accountTypeOptions: [{ dictLabel: '腾讯', dictValue: 1 }, { dictLabel: '巨量', dictValue: 2 }, { dictLabel: '百度', dictValue: 3 },
          { dictLabel: 'B站', dictValue: 4 }, { dictLabel: '京东', dictValue: 5 }, { dictLabel: '快手', dictValue: 6 }]
      }
    }
  },
  async created() {
    // 存在 读缓存
    if (sessionStorage.getItem('rechargeSearch')) {
      this.queryParams = JSON.parse(sessionStorage.getItem('rechargeQuery'))
      this.queryParams.pageSize = this.queryParams.pageNum * 10
      this.queryParams.pageNum = 1
      document.documentElement.scrollTop = this.queryParams.scrollTop
      this.active = this.queryParams.execType
    } else {
      sessionStorage.removeItem('rechargeQuery')
    }
    if (this.$route.query.active) {
      this.active = this.$route.query.active
      this.queryParams.execType = this.$route.query.active
    }
    await this.handleList()
    await this.getCountItem()
    if (sessionStorage.getItem('rechargeSearch')) {
      document.documentElement.scrollTop = this.queryParams.scrollTop
    }
  },
  mounted() {
    this.init()
  },
  destroyed() {
    // 销毁组件
    sessionStorage.removeItem('rechargeSearch')
    // sessionStorage.removeItem('paymentQuery')
  },
  methods: {
    async init() {
      document.title = '广告退款审批'
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.queryParams.contractName = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryParams.startTimeStr = data.params.beginTime
      this.queryParams.endTimeStr = data.params.endTime
      this.queryParams.params = null
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      sessionStorage.removeItem('rechargeSearch')
      sessionStorage.removeItem('rechargeQuery')
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
      this.getCountItem()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      this.queryParams.scrollTop = scrollTop
      sessionStorage.setItem('rechargeQuery', JSON.stringify(this.queryParams))
      this.$router.push({
        path: '/fina/refundManagement/approvalDetail',
        query: { arvId: item.arvId }
      })
    },
    async handleList() {
      this.loading = true
      let res = null
      res = await refund.listRefundVerify({ ...this.queryParams, execType: null })
      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        if (this.queryParams.pageSize > 10 && this.queryParams.pageNum == 1) {
          this.queryParams.pageNum = this.queryParams.pageSize / 10
          this.queryParams.pageSize = 10
        }
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    // 查询数量
    getCountItem() {
      // this.queryParams.execType = null
      refund.getRefundVerifyCount({ ...this.queryParams, acconutStatus: null }).then(res => {
        if (res.code === 200) {
          this.countItem = res.data
        }
      })
    },
    onLoad() {
      this.handleList()
      this.getCountItem()
    },
    handleClick(tab, event) {
      this.queryParams.acconutStatus = tab
      this.queryCustList()
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
.cust /deep/.van-dialog__content {
  padding: 0 20px;
}
</style>
